import firebase from "firebase/app";
import 'firebase/auth';        // for authentication
import 'firebase/storage';     // for storage
import 'firebase/database';    // for realtime database
import 'firebase/firestore';   // for cloud firestore
import 'firebase/messaging';   // for cloud messaging
import 'firebase/functions';   // for cloud functions
import { firebasePublicKey } from "./api/apiConsts";

const config = {
  apiKey: "AIzaSyDpLr_54y_Gat6wpEkdwCOk7cCHqJOLIxA",
  authDomain: "agalia-nurseapp.firebaseapp.com",
  projectId: "agalia-nurseapp",
  storageBucket: "agalia-nurseapp.appspot.com",
  messagingSenderId: "777088927666",
  appId: "1:777088927666:web:ceb4df4b9dd59f219546ab",
  measurementId: "G-T4D7EB8JEQ",
};

firebase.initializeApp(config);

const handleUrl = (type, id) => {
  let returnUrl = "";
  switch (type) {
    case "CREDENTIAL":
      returnUrl = `/nurses/nurse-detail?type=cred&nurse_id=${id}`;
      break;

    case "PAYROLL":
      returnUrl = `/payments`;
      break;
    case "PAYMENT":
      returnUrl = `/payments/payroll/list`;
      break;
 
    default:
      console.log(`Sorry, not defined route`);
  }
  return returnUrl;
};

const setupToken = async () => {
  try {
    const messaging = firebase.messaging();

    messaging.onMessage((payload) => {
      navigator.serviceWorker
        .getRegistration("/firebase-cloud-messaging-push-scope")
        .then((registration) => {
          registration.showNotification(payload.notification.title, {
            ...payload.notification,
            data: { url: handleUrl(payload.data.type, payload.data.type_id) },
          });
        });
    });
    const token = await messaging.getToken({ vapidKey: firebasePublicKey });
    if (token) {
      return token;
    }
  } catch (e) {
    return null;
  }
};

const DeleteFirebaseToken = async () => {
  try {
    const messaging = firebase.messaging();
    messaging.deleteToken();
  } catch (e) {
    return null;
  }
};

setupToken();

export { setupToken, DeleteFirebaseToken };
